import { useContext } from "react";
import { DataManCellContext } from "../defines";

export const useDataManCell = () => {
  const context = useContext(DataManCellContext);
  if (context === undefined) {
    throw new Error("useDataManCell must be used within a DataManCellProvider");
  }
  return context;
};
